var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5L23.5 23.5M8 7.5V15.5M14 7.5V15.5M8.5 7.5C8.5 6.83696 8.76339 6.20107 9.23223 5.73223C9.70107 5.26339 10.337 5 11 5C11.663 5 12.2989 5.26339 12.7678 5.73223C13.2366 6.20107 13.5 6.83696 13.5 7.5M11 21.5C5.201 21.5 0.5 16.799 0.5 11C0.5 5.201 5.201 0.5 11 0.5C16.799 0.5 21.5 5.201 21.5 11C21.5 16.799 16.799 21.5 11 21.5ZM17 15.5H5V15.25L5.128 14.48C5.45689 12.5069 5.45689 10.4931 5.128 8.52L5 7.75V7.5H17V7.75L16.872 8.52C16.5431 10.4931 16.5431 12.5069 16.872 14.48L17 15.25V15.5Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDetails);
export default __webpack_public_path__ + "static/media/customDetails.fe15202dfb476f175eb2a7022f235649.svg";
export { ForwardRef as ReactComponent };